import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import {
  clearLocalStorage,
  setUsetDetailToLocalStorage,
} from "../../utils/helper";
import { notification } from "antd";
import history from "../../utils/history";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
  },
  reducers: {
    setUserDetail: (state, action) => {
      state.user = action.payload;
    },
    clearUserDetail: (state) => {
      state.user = null;
    },
  },
});

export const { setUserDetail, clearUserDetail } = authSlice.actions;

export const selectUser = (state) => state.auth.user;

export default authSlice.reducer;

export const login = (data, callback) => (dispatch) => {
  axios
    .post("/auth/signin", data)
    .then(({ data }) => {
      if (data?.accessToken) {
        setUsetDetailToLocalStorage(data);
        dispatch(setUserDetail(data));
        callback && callback();
        history.push("/home");
      }
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const logout = () => (dispatch) => {
  dispatch(clearUserDetail());
  clearLocalStorage();
};
